import { Variants } from 'framer-motion';
import { darkModeColors } from '../../../../util';

export const floatingTagListVariants: Variants = {
  open: ({ x, y }) => ({
    x,
    y,
    background: darkModeColors.neutral,
    borderRadius: 16,
    boxShadow: '0 6px 12px 4px rgba(0, 0, 0, 0.2), inset 0 1px 0 0 rgba(88, 95, 102, 0.32)',
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  }),
  closed: ({
    x: 0,
    y: 0,
    background: `${darkModeColors.gray.background}00`,
    borderRadius: 0,
    boxShadow: '0 6px 12px 4px rgba(0, 0, 0, 0), inset 0 1px 0 0 rgba(88, 95, 102, 0)',
    transition: {
      duration: 0.5,
      ease: 'easeInOut',
    },
  }),
};
